import React from 'react';
import styled, { css } from 'styled-components';
import successNoBg from '../../assets/images/success-nobg.png';

const StyledLabel = styled.label`
  all: unset;
  font-size: 1.6rem;
  color: var(--color-black);
  margin: 0px;
  line-height: ${(props) => props.lineHeight ? props.lineHeight : "1"};
  .label-invisible {
    display: none !important;
  }
  .label-clickable {
    cursor: pointer;
    color: var(--color-tan_two);
  }
  .label-verified {
    display: flex;
    flex-direction: row;
    align-items: center;
    #img-label-verified {
      margin-left: 0.25em;
      width: 1.2em;
    }
  }

  .label-error {
    color: var(--color-error_red);
  }

  ${(props) =>
    props.mobile &&
    css`
      font-size: 1.6rem;
    `}
`;

const Label = ({
  className = '', // Add className="error" to show RED colored label.
  text = 'Label',
  visible = true,
  verified = false,
  error = false,
  clickable = false,
  clickable_method = undefined,
  lineHeight = 1,
  ...props
}) => {
  if (visible) {
    return (
      <StyledLabel style={props.style} {...props}>
        {clickable ? (
          <label className="label-clickable" onClick={clickable_method} {...props}>
            {text}
          </label>
        ) : verified && error ? (
          <label className="label-verified label-error" {...props}>
            {text}
            <img id="img-label-verified" src={successNoBg} alt="✔" />
          </label>
        ) : verified ? (
          <label className="label-verified" {...props}>
            {text}
            <img id="img-label-verified" src={successNoBg} alt="✔" />
          </label>
        ) : error ? (
          <label className="label-error" {...props}>
            {text}
          </label>
        ) : (
          <label className="label" {...props}>
            {text}
          </label>
        )}
      </StyledLabel>
    );
  } else {
    return <div></div>;
  }
};
export default Label;
